import { createActions } from "redux-actions";

export const constants = {
  SUBMIT_BRIEFING_FORM: "SUBMIT_BRIEFING_FORM",
  FETCH_BRIEFING_LIST: "FETCH_BRIEFING_LIST",
  DELETE_BRIEFING: "DELETE_BRIEFING",
  UPDATE_BRIEFING: "UPDATE_BRIEFING",
  FETCH_BRIEFING: "FETCH_BRIEFING",
  UPDATE_BRIEFING_FORM_FIELD: "UPDATE_BRIEFING_FORM_FIELD",
  UPDATE_BRIEFING_SEARCH_QUERY: "UPDATE_BRIEFING_SEARCH_QUERY",
  RESET_BRIEFING_FORM_FIELDS: "RESET_BRIEFING_FORM_FIELDS",
  NEXT_BRIEFINGS_PAGE: "NEXT_BRIEFINGS_PAGE",
  PREV_BRIEFINGS_PAGE: "PREV_BRIEFINGS_PAGE",
  LAST_BRIEFINGS_PAGE: "LAST_BRIEFINGS_PAGE",
  FIRST_BRIEFINGS_PAGE: "FIRST_BRIEFINGS_PAGE",
};

export const actions = createActions({
  SUBMIT_BRIEFING_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  FETCH_BRIEFING_LIST: {
    REQUEST: ({ query }) => ({}),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  DELETE_BRIEFING: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  UPDATE_BRIEFING: {
    REQUEST: ({ briefing }) => ({ briefing }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  FETCH_BRIEFING: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  RESET_BRIEFING_FORM_FIELDS: (showMessage = true) => ({ showMessage }),
  NEXT_BRIEFINGS_PAGE: () => ({}),
  PREV_BRIEFINGS_PAGE: () => ({}),
  LAST_BRIEFINGS_PAGE: () => ({}),
  FIRST_BRIEFINGS_PAGE: () => ({}),
});
